import React from 'react';

import cn from 'utils/cn';

import './index.css';

export const cnLogo = cn('logo');

interface ILogoProps {
    url: string;
    language: string;
}

function Logo({ url, language }: ILogoProps) {
    const lang = ['en', 'tr', 'zh-Hans'].indexOf(language) > -1 ? 'en' : 'ru';

    return (
        <a
            className={cnLogo({ lang })}
            href={url}
            />
    );
}

export default Logo;
